var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('section',{attrs:{"id":"wrapper"}},[(_vm.section == 'faq')?[_c('Faq')]:(_vm.section == 'tos')?[_c('Tos')]:(_vm.section == 'privacy')?[_c('Privacy')]:(_vm.section == 'coupon')?[_c('Coupon')]:(_vm.section == 'download')?[_c('Download')]:(_vm.section == 'membership')?[_c('Membership')]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fbaea3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageForChina.vue
// module id = null
// module chunks = 